import $ from 'jquery';
import 'rateyo';
import 'rateyo/src/jquery.rateyo.css';
import {updateModelValueEmit} from './inputs/currency-price';

function initStarRatingComponent(app) {
    app.component('star-rating',
        {
            template: '#star-rating-template',
            inheritAttrs: false,
            props: {
                category: {type: String},
                rating: {default: 0},
                starWidth: {default: '0.8em'},
                halfStar: {default: false},
                fullStar: {default: true},
                normalFill: {default: '#dee9eb'},
                ratedFill: {default: '#ffd700'},
                readOnly: {type: Boolean},
                pointName: {type: String},
                catName: {type: String},
                starTooltips: {required: false},
                modelValue: {required: false},
                isWithLabel: {type: Boolean, default: false},
            },
            emits: [updateModelValueEmit],
            data() {
                return {
                    isEditMode: false,
                    oldValue: this.modelValue,
                    starCount: this.rating,
                    formattedRating: (Number(this.rating)).toFixed(1),
                    tooltipsArray: typeof this.starTooltips === 'string' ? this.getArrayFromString(this.starTooltips) : this.starTooltips,
                    hoveredStar: null,
                };
            },
            watch: {
                starCount(newValue) {
                    $(this.$refs.stars).rateYo('rating', newValue);
                    this.$emit(updateModelValueEmit, newValue);
                },
            },
            computed: {
                showTooltip() {
                    return this.starTooltips && this.starTooltips !== '' && this.starTooltips !== 'null' && this.hoveredStar;
                },
                currentTooltip() {
                    return this.tooltipsArray[this.hoveredStar - 1];
                },
            },
            mounted() {
                $(this.$refs.stars).rateYo({
                    rating: this.rating,
                    starWidth: this.starWidth,
                    halfStar: this.halfStar,
                    fullStar: this.fullStar,
                    normalFill: this.normalFill,
                    ratedFill: this.ratedFill,
                    readOnly: this.readOnly,
                    onChange: (starCount) => {
                        this.hoveredStar = starCount;
                    },
                    onSet: (starCount) => {
                        this.starCount = starCount;
                        this.$emit(updateModelValueEmit, this.starCount);
                    },
                });
            },
            methods: {
                getArrayFromString(string) {
                    return string.replace('[\'', '').replace('\']', '').split('\',\'').map(String);
                },
            },
        });

    app.component('rating-details',
        {
            template: '#rating-details',
            props: {
                totalRating: {type: Number},
                reviewsAmount: {type: Number},
                ratings: {type: Object},
                date: {
                    type: String,
                    default: null,
                },
            },
            methods: {
                hideRatingDetails() {
                    this.$refs.ratingDetails.close();
                },
            },
        });
}

export default initStarRatingComponent;
